export default  require('@os-store/booking/menu')



// WEBPACK FOOTER //
// ./store/booking/menu.js